module.exports = __webpack_public_path__ + "media/images/brands/github-82e165217fec46ba71c85984a8614610.png";